import { render, staticRenderFns } from "./RegionRetailersSectionModule.vue?vue&type=template&id=190bb854&"
import script from "./RegionRetailersSectionModule.vue?vue&type=script&lang=js&"
export * from "./RegionRetailersSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports